import { useState } from 'react';

export default function WhatsAppFloat() {
  const [hovered, setHovered] = useState(false);
  const whatsappNumber = '16479540663';
  const message = encodeURIComponent('Hi! I\'d like to get a quote for landscaping services.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed bottom-6 right-6 z-50 flex items-center cursor-pointer group"
      aria-label="Chat on WhatsApp"
    >
      {/* Tooltip label */}
      <span
        className={`mr-3 bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-full shadow-lg whitespace-nowrap transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        Chat with us on WhatsApp
      </span>

      {/* Button */}
      <div className="relative w-14 h-14 flex items-center justify-center">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-green-400 opacity-30 animate-ping"></span>
        <div
          className="w-14 h-14 flex items-center justify-center rounded-full shadow-xl transition-transform duration-200 group-hover:scale-110"
          style={{ backgroundColor: '#25D366' }}
        >
          <i className="ri-whatsapp-line text-white text-3xl"></i>
        </div>
      </div>
    </a>
  );
}
